export default {
	action: '',
	users: [],
	modules: []
}